module.exports = __webpack_public_path__ + "img/ad-screenshot-example.364ee12c.jpg";